






















import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import Vue from 'vue'
import Component from 'vue-class-component'
import { DisplayItem } from '@app/componentlib/src/common/types/profileTypes'
import { ga } from '@app/componentlib/src/application/analytics'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

@Component<DisplaySkillItem>({
  props: {
    item: Object,
    itemProp: String,
    includeDate: Boolean,
    tooltip: String
  },
  components: {
    VPopover
  },
  directives: {
    VTooltip,
    VClosePopover
  }
})

export default class DisplaySkillItem extends Vue {
  /**
   * Props variables
   */
  item: DisplayItem | undefined
  itemProp: string | undefined
  includeDate: boolean | undefined
  tooltip: string | undefined

  /**
   * Component state variables
   */
  preview = true

  /**
   * Lifecycle
   */
  mounted () {
    if (this.item !== undefined) {
      //Check if item should be preview false
      const excludeList = CvModule.excludePreviewList
      if (excludeList !== undefined && this.item !== undefined) {
        const itemId = this.item ? this.item.Id : null
        const isExcluded = excludeList.find(exItem => exItem.id === itemId)
        this.preview = !isExcluded
      }
    }
  }


  /**
   * Getters
   */


  /**
   * Methods
   */
  findProp (item: any) {
    if (this.itemProp !== undefined) {
      return item[this.itemProp]
    }
    return item.text
  }

  toggleItem (item: any) {
    console.log('CLICK?', item)
    this.preview = !this.preview
    if (this.preview === false) {
      CvModule.excludeItem(item)
    } else {
      CvModule.includeItem(item)
    }
    const gaLabel = this.preview === false ? 'excludeItem' : 'includeItem'
    ga.event({
      action: 'Display skills',
      category: 'CV Tool',
      label: gaLabel,
    })
  }

  getDisplayLevelText (item: any) {
    if (!item) return '' // Guard clause
    // Check for lowercase 'levelText', then uppercase 'LevelText'
    const levelText = item.levelText || item.LevelText || ''
    // Return it formatted with a comma and space if found, otherwise empty string
    return levelText ? `, ${levelText}` : ''
  }

  getDisplayLevel (item: any) {
    if (!item) return '' // Guard clause
    // Check for lowercase 'level', then uppercase 'Level'
    return item.level || item.Level || ''
  }
}
